<template>
  <h2 class="h4 c-section-title">
    <slot></slot>
  </h2>
</template>
<script>
export default {
  methods: {}
};
</script>

<style lang="scss">
.c-section-title {
  // &::before {
  //   display: block;
  //   content: " ";
  //   margin-top: -78px;
  //   height: 78px;
  //   visibility: hidden;
  // }
  &::after {
    height: 0.2em;
    background: #ec5f71;
    background: -moz-linear-gradient(
      left,
      #ec5f71 0%,
      #ec5f71 20%,
      #c7cf00 20%,
      #c7cf00 40%,
      #f6a000 40%,
      #f6a000 60%,
      #44bdd2 60%,
      #44bdd2 100%
    );
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      color-stop(0%, #ec5f71),
      color-stop(20%, #ec5f71),
      color-stop(20%, #c7cf00),
      color-stop(40%, #c7cf00),
      color-stop(40%, #f6a000),
      color-stop(60%, #f6a000),
      color-stop(60%, #44bdd2),
      color-stop(100%, #44bdd2)
    );
    background: -webkit-linear-gradient(
      left,
      #ec5f71 0%,
      #ec5f71 20%,
      #c7cf00 20%,
      #c7cf00 40%,
      #f6a000 40%,
      #f6a000 60%,
      #44bdd2 60%,
      #44bdd2 100%
    );
    background: -o-linear-gradient(
      left,
      #ec5f71 0%,
      #ec5f71 20%,
      #c7cf00 20%,
      #c7cf00 40%,
      #f6a000 40%,
      #f6a000 60%,
      #44bdd2 60%,
      #44bdd2 100%
    );
    background: -ms-linear-gradient(
      left,
      #ec5f71 0%,
      #ec5f71 20%,
      #c7cf00 20%,
      #c7cf00 40%,
      #f6a000 40%,
      #f6a000 60%,
      #44bdd2 60%,
      #44bdd2 100%
    );
    background: linear-gradient(
      to right,
      #ec5f71 0%,
      #ec5f71 20%,
      #c7cf00 20%,
      #c7cf00 40%,
      #f6a000 40%,
      #f6a000 60%,
      #44bdd2 60%,
      #44bdd2 100%
    );
    // border-bottom: 0.2em solid var(--primary);
    content: "";
    display: block;
    margin: 0.4em 0 0.7em;
    width: 8.5em;
  }
}
</style>
